<template>
  <Layout>
    <div class="is-size-7 p-md">
      <div class="has-text-centered" style="margin:auto;max-width:600px;">
        <GameTile :game="game" class="has-text-left" />
        <p class="is-size-5 has-text-primary">Game Game - Igraj sad!</p>
        <div lass="m-md">
          <a class="button is-primary is-size-3" href="sms:4097?body=AAA">Aktivirajte</a>
        </div>
        <p class="is-size-7 m-t-lg">
          GameGa.me. Ovo je pretplatnička usluga, gde vam pružamo najbolji svet zabave za Android i iPhone - najpopularnije igre će vam uvek biti u blizini. Usluga košta 180 DIN/sms, 2 sms/nedeljno (plus cena osnovnog SMSa: MTS 3,60 DIN, Telenor 3,60 DIN, Vip 3,48 DIN). Da biste otkazali uslugu, pošaljite STOP AAA na 4097 (VIP, Telenor) i STOPAAA na 4097 (Telekom / MTS). Uključivanjem usluga dobićete pristup kompaniji We offer you the best of the world of entertainment for Android. Naše aplikacije su zabavne, jednostavne za korištenje i olakšavaju život. Nudimo igre sa raznim kategorijama. Svake nedelje, mi lično birate i ističemo aplikacije koje su idealne za vas. Po pristupačnoj nedeljnoj ceni, moći ćete da pristupite svim našim aplikacijama besplatno i otkrivate bogat izbor inovativnih sadržaja za vaš telefon. Potpisivanjem i / ili korišćenjem usluga potvrdite da ste pročitali i složili se sa Opštim i specifičnim uslovima poslovanja, da ste rezident Srbije, da ste stariji od 16 godina ili stariji i da ste ovlašćeni vlasnika računa ili da imate saglasnost vlasnika računa. Primjenjuje se standardni trošak operatera SMS / WAP / GPRS / UMTS. 
          GameGa.me je zaštitni znak kompanije 778mobile GmbH i pruža inovativne informacije i zabavu za vaš mobilni telefon. koji nisu povezani, niti sponzorirani niti podržani od bilo kog od gore navedenih proizvoda ili trgovaca. Imena trgovaca, oznake usluga, logotipi (uključujući, bez ograničenja, pojedinačna imena proizvoda ili trgovci) su vlasništvo njihovih pojedinačnih vlasnika. 778mobile GmbH, Am Wehrhahn 50, 40211 Düsseldorf. Privatni registarski broj HRB 79227 PDV broj DE303966009. Podrška: 778mobile.rs@silverlines.info / 00381113216815. Tehnički pružalac usluge NTH Media d.o.o. Beograd.
        </p>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'
import GameTile from '@/components/LangGG/GameTile'

export default {
  name: 'Home',
  components: {
    Layout,
    GameTile
  },
  data () {
    return {
      isMsisdn: true,
      msisdn: '0',
      carrier: '23001',
      game: {
        name: 'Speed Pool King',
        path: 'https://assets.gamega.me/avi/SpeedPoolKing_0304/index.html',
        icon: 'https://assets.gamega.me/avi/SpeedPoolKing_0304/sqricon.png',
        tags: [ 'Ability', 'Action', 'Maximum score' ],
        votes: 29,
        score: 3.7241379310344827,
        id: 111
      }
    }
  },
  computed: {
    hasValidMsisdn () {
      return this.msisdn.match(/^(00420|0|\+420|420)?([1-9][0-9]+)/) instanceof Array
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangKyf/RS/LP.vue